import { useState } from "react";
import { TrendingDown } from "lucide-react";
import { toast } from "sonner";
import { api, errText } from "../../lib/api";
import { useLanguage } from "../../context/LanguageContext";
import { Switch } from "../ui/switch";

export function PriceDropPref({ user }) {
  const { lang } = useLanguage();
  const fr = lang === "fr";
  const [on, setOn] = useState(user?.price_drop_emails !== false);
  const [saving, setSaving] = useState(false);
  const toggle = async (v) => {
    setOn(v); setSaving(true);
    try {
      await api.put("/auth/me/preferences", { price_drop_emails: v });
      toast.success(v ? (fr ? "Alertes de baisse de prix activées" : "Price drop alerts on") : (fr ? "Alertes de baisse de prix désactivées" : "Price drop alerts off"));
    } catch (e) { setOn(!v); toast.error(errText(e)); }
    finally { setSaving(false); }
  };
  return (
    <div className="max-w-xl bg-white rounded-2xl border border-slate-200/80 p-6 flex items-start gap-4" data-testid="price-drop-pref">
      <span className="h-10 w-10 rounded-xl bg-[#FFF4F0] flex items-center justify-center shrink-0"><TrendingDown size={20} className="text-[#F5551E]" /></span>
      <div className="flex-1">
        <p className="font-display font-bold text-[#12234A]">{fr ? "Alertes de baisse de prix" : "Price drop alerts"}</p>
        <p className="text-sm text-slate-500 mt-0.5">{fr ? "Recevez un courriel quand une annonce de vos favoris baisse de prix." : "Get an email when a pet you've hearted drops in price."}</p>
      </div>
      <Switch checked={on} disabled={saving} onCheckedChange={toggle} data-testid="price-drop-toggle" />
    </div>
  );
}
